import React, { Fragment } from 'react';
import { BreadcrumbWrapper, BreadcrumbItemWrapper } from './Breadcrumb.style';

export interface BreadcrumbItem {
  url?: string;
  text: React.ReactNode;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <BreadcrumbWrapper data-test="breadcrumb">
      {items.map((item, i) => (
        <BreadcrumbItemWrapper key={i} data-test="breadcrumb-item">
          {item.url ? (
            <Fragment>
              <a href={item.url}>{item.text}</a>
              &ensp; {' / '} &ensp;
            </Fragment>
          ) : (
            <Fragment>{item.text}</Fragment>
          )}
        </BreadcrumbItemWrapper>
      ))}
    </BreadcrumbWrapper>
  );
};
